import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ReservasService } from 'src/app/services/reservas.service';
import { faBookmark, faCircleCheck } from '@fortawesome/pro-light-svg-icons';

export interface DialogSaveReservationData {
  cartId: number;
}

@Component({
  selector: 'app-dialog-save-reservation',
  templateUrl: './dialog-save-reservation.component.html',
  styleUrls: ['./dialog-save-reservation.component.scss'],
})
export class DialogSaveReservationComponent {
  faBookmark = faBookmark;
  faCircleCheck = faCircleCheck;

  step: 1 | 2 | 3 = 1;
  reservationName: string = '';
  saving: boolean = false;
  error: string = '';
  savedReservationId: number | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogSaveReservationData,
    private dialogRef: MatDialogRef<DialogSaveReservationComponent>,
    private reservasService: ReservasService,
    private router: Router
  ) {}

  confirm() {
    this.step = 2;
  }

  save() {
    const name = this.reservationName.trim();
    if (!name || this.saving) return;

    this.saving = true;
    this.error = '';

    this.reservasService.fromCart(this.data.cartId, name).subscribe({
      next: (res) => {
        this.saving = false;
        this.savedReservationId = res?.data?.id || res?.id || null;
        this.step = 3;
      },
      error: (err) => {
        this.saving = false;
        this.error = this.mapError(err);
      },
    });
  }

  goToReservation() {
    this.dialogRef.close({ saved: true, name: this.reservationName.trim() });
    this.router.navigate(['/reservas', this.savedReservationId]);
  }

  close() {
    this.dialogRef.close({ saved: true, name: this.reservationName.trim() });
  }

  cancel() {
    this.dialogRef.close(null);
  }

  private mapError(err: any): string {
    const status = err?.status;
    if (status === 422) return err?.error?.message || 'Solo se pueden convertir carritos en estado abierto';
    if (status === 403) return 'No tienes permisos para realizar esta acción';
    if (status === 404) return 'Carrito no encontrado';
    return 'Error al crear la reserva, inténtalo de nuevo';
  }
}
